const CommentsEntityTypes = {
  post: 'post',
  material: 'material',
};

export const Entities = {
  post: 'posts',
  material: 'materials',
};

export const EntityTypesByCollections = {
  UBClassRoomPost: CommentsEntityTypes.post,
  UBClassRoomMaterialModule: CommentsEntityTypes.material,
};

export default CommentsEntityTypes;
